import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { propTypesEvent } from '../../../templates/Event/Event.proptypes';
import { propTypesPost } from '../../../templates/Post/Post.proptypes';
import { propTypesLocalization } from '../../constants/Proptypes';

import ShareMenu from '../../../ui/Molecules/SharedMenu';

import { useSize } from '../../hooks/useSize';
import * as S from './ShareSection.styles';

export const ShareSection = ({ isVisible, localization, page }) => {
  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const screenMidHeight = useSize().height / 2;

  if (!page || !localization) {
    return null;
  }

  const { title } = page || '';
  const { text: articleName } = title || '';
  const { data: { share_label: menuLabel } = {} } = localization || '';

  return (
    <S.Container isVisible={isVisible} position={screenMidHeight}>
      <S.Wrapper>
        <S.MenuWrapper>
          <ShareMenu
            articleName={articleName || title}
            menuLabel={menuLabel}
            pageUrl={currentUrl}
          />
        </S.MenuWrapper>
      </S.Wrapper>
    </S.Container>
  );
};

ShareSection.propTypes = {
  /**
   * Display the component or not.
   */
  isVisible: PropTypes.bool,
  /**
   * Localization document.
   */
  localization: PropTypes.shape(propTypesLocalization),
  /**
   * Document type.
   */
  page: PropTypes.shape(propTypesPost.data || propTypesEvent.data),
};
